import { refundHoldModeValues } from '@/common/constants'

export const refundHoldModeOptions = [
  { label: 'Retener indefinidamente', value: refundHoldModeValues.holdIndefinitely },
  { label: 'Retrasar X días', value: refundHoldModeValues.delayByDays },
]
